module.exports = __webpack_public_path__ + "img/pc2.dfdfc7fc.jpg";